module.exports = __webpack_public_path__ + "img/team-2.2451fb86.jpg";